export default __webpack_public_path__ + "static/media/discord-icon-dev.909eaf76.png";